import { CrownOutlined, UserOutlined } from "@ant-design/icons";

const dashboardThemes = {
  teamLeader: {
    accent: "#2563EB",
    accentLight: "#EFF6FF",
    accentSoft: "#2563EB14",
    border: "border-[#2563EB]/20",
    badge: "Team Leader Dashboard",
    role: "Team Leader",
    icon: CrownOutlined,
    title: "Lead your team to success",
  },
  teamMember: {
    accent: "#7367F0",
    accentLight: "#7367F038",
    accentSoft: "#7367F014",
    border: "border-[#7367F0]/20",
    badge: "Team Member Dashboard",
    role: "Team Member",
    icon: UserOutlined,
    title: "Grow your sales journey",
  },
};

export default function SalesDashboardHeader({ isTeamLeader, userDetails }) {
  const userName =
    userDetails?.fullName ||
    [userDetails?.firstName, userDetails?.lastName].filter(Boolean).join(" ") ||
    userDetails?.name ||
    "Sales User";

  const theme = isTeamLeader
    ? dashboardThemes.teamLeader
    : dashboardThemes.teamMember;
  const Icon = theme.icon;

  return (
    <div
      className={`relative overflow-hidden rounded-[14px] border-2 ${theme.border} bg-white shadow-[0_8px_24px_rgba(15,23,42,0.06)]`}
    >
      <div
        className="absolute left-0 top-0 h-full w-1.5"
        style={{ backgroundColor: theme.accent }}
      />
      <div
        className="absolute -right-10 -top-10 h-36 w-36 rounded-full"
        style={{ backgroundColor: theme.accentSoft }}
      />
      <div
        className="absolute -bottom-12 right-24 h-28 w-28 rounded-full"
        style={{ backgroundColor: theme.accentSoft }}
      />

      <div className="relative px-5 py-5 md:px-7 md:py-6">
        <div className="flex flex-wrap items-start justify-between gap-5">
          <div className="flex gap-4 min-w-0 flex-1">
            <div
              className="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl shadow-sm"
              style={{ backgroundColor: theme.accentLight, color: theme.accent }}
            >
              <Icon className="text-2xl" />
            </div>

            <div className="min-w-0">
              <span
                className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-wide"
                style={{
                  backgroundColor: theme.accentLight,
                  color: theme.accent,
                }}
              >
                <Icon />
                {theme.badge}
              </span>

              <h1 className="mt-3 text-xl md:text-2xl font-bold text-[#2F2B3D]">
                Welcome, {userName}
              </h1>
              <p
                className="mt-1 text-sm font-semibold"
                style={{ color: theme.accent }}
              >
                {theme.title}
              </p>
            </div>
          </div>

          <div
            className="min-w-[190px] rounded-2xl border px-4 py-4 shadow-sm"
            style={{
              borderColor: `${theme.accent}25`,
              backgroundColor: theme.accentLight,
            }}
          >
            <p
              className="text-[11px] font-bold uppercase tracking-wider"
              style={{ color: theme.accent }}
            >
              Your Role
            </p>
            <p className="mt-2 text-lg font-bold text-[#2F2B3D]">
              {theme.role}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
